import {
  getSimpleMaterials,
  QueryOptionsItem,
} from "./component/FilterPanel/FilterPanel";
import request from "./api/request";
import { BackendAPI } from "./const/api";

export const getOrderQueryOptions = async (
  customer: boolean = true,
  admin: boolean = false,
) => {
  let customers: Promise<QueryOptionsItem[]> = Promise.resolve([]);
  let salespersons: Promise<QueryOptionsItem[]> = Promise.resolve([]);
  const materials: Promise<QueryOptionsItem[]> = getSimpleMaterials();
  if (!customer) {
    if (admin) {
      customers = request
        .get(BackendAPI.customerAll)
        .then((res) => {
          if (!res.success) {
            return [];
          }
          const fetchedCustomers = res.data;
          return fetchedCustomers.map(
            (c) =>
              ({
                value: c["id"],
                label: c["name"],
                data: c,
              }) as QueryOptionsItem,
          );
        })
        .catch(() => []);
    }
    salespersons = request.get(BackendAPI.listSalesperson).then((res) => {
      if (!res.success) {
        return [];
      }
      const fetchedSalespersons = res.data;
      return fetchedSalespersons.map(
        (s) =>
          ({
            value: s,
            label: s,
          }) as QueryOptionsItem,
      );
    });
  }
  return Promise.all([materials, customers, salespersons]);
};

export const getLastSyncTime = async (tName) => {
  const res = await request.get(BackendAPI.lastSyncTime, { tName });
  if (!res.success) {
    return "";
  }
  return res.data.lastSyncTime;
};
